// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "body{\n  background-color: #b1adad!important;\n\n}\n\n.green{\n  color: green;\n}\n\n.red{\n  color: red;\n}", "",{"version":3,"sources":["webpack://src/Cryptos/app.css"],"names":[],"mappings":"AAAA;EACE,mCAAmC;;AAErC;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,UAAU;AACZ","sourcesContent":["body{\n  background-color: #b1adad!important;\n\n}\n\n.green{\n  color: green;\n}\n\n.red{\n  color: red;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
